export const TABLE_UPDATE = "GROUPS/TABLE_UPDATE";
export const FETCH_SUCCESS = "GROUPS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "GROUPS/DESTROY_FAILED",
    DESTROY_REQUEST: "GROUPS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "GROUPS/DESTROY_SUCCESS",

    FETCH_FAILED: "GROUPS/FETCH_FAILED",
    FETCH_REQUEST: "GROUPS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "GROUPS/GET_FAILED",
    GET_REQUEST: "GROUPS/GET_REQUEST",
    GET_SUCCESS: "GROUPS/GET_SUCCESS",

    PATCH_FAILED: "GROUPS/PATCH_FAILED",
    PATCH_REQUEST: "GROUPS/PATCH_REQUEST",
    PATCH_SUCCESS: "GROUPS/PATCH_SUCCESS",

    STORE_FAILED: "GROUPS/STORE_FAILED",
    STORE_REQUEST: "GROUPS/STORE_REQUEST",
    STORE_SUCCESS: "GROUPS/STORE_SUCCESS",

    UPDATE_FAILED: "GROUPS/UPDATE_FAILED",
    UPDATE_REQUEST: "GROUPS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "GROUPS/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
